import _ from 'lodash';
import { format } from 'date-fns';

import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest
} from '../../Common/network-call';
import { EVENT_DETAILS } from '../../../actions';
import {
  downloadFileFromURL,
  shuffleComments
} from '../../../util/util-common';
import { ALLOWED_SCHEDULEDATE_APICALL_SOURCE } from '../../../constants/section-constants/source-constant';
import { ALLOWED_GAME_CHALLENGE_TYPES } from '../../../constants/section-constants/gamification-constants';
import {
  DATE_FORMAT_FNS,
  PORTAL_LOCALSTORAGE_ACCESS_KEY,
  SCRIPT_URI_ADDON,
  SESSION_NO_TRACK,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import { loadFromLocalDB } from '../../../reducers/localStorage';
import {
  ALLOWED_SCHEDULE_VIEWS,
  ALLOWED_SESSION_CHECKED_IN_TYPES
} from '../../../constants/section-constants/type-constants';
import {
  fetchGameChallengeStatus,
  setGamificationPopup
} from '../../gamification/actions';
import { showToast } from '../../Common/alertmessage';
import LocalStrings from '../../../assets/languages';

export const FETCH_SCHEDULES_DATA_FULFILLED = 'FETCH_SCHEDULES_DATA_FULFILLED';
export const SELECT_SCHEDULE_DATE = 'SELECT_SCHEDULE_DATE';
export const FETCH_SCHEDULES_TRACKS_DATA = 'FETCH_SCHEDULES_TRACKS_DATA';
export const FETCH_TRACK_SESSIONS_DATA = 'FETCH_TRACK_SESSIONS_DATA';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';
export const FETCH_SESSION_LIVEQA_DATA = 'FETCH_SESSION_LIVEQA_DATA';
export const OPEN_QA_MODAL = 'OPEN_QA_MODAL';
export const SESSION_POLL_LIST = 'SESSION_POLL_LIST';
export const SESSION_POLL_LIST_MODAL = 'SESSION_POLL_LIST_MODAL';
export const SESSION_POLL_ACTION_MODAL = 'SESSION_POLL_ACTION_MODAL';
export const SESSION_POLL_RESULT = 'SESSION_POLL_RESULT';
export const MY_BOOKED_SCHEDULE = 'MY_BOOKED_SCHEDULE';
export const MY_RATED_SESSION = 'MY_RATED_SESSION';
export const HOLD_THIS_SESSION_DETAILS = 'HOLD_THIS_SESSION_DETAILS';
export const FETCH_LIVEQA_REPLY = 'FETCH_LIVEQA_REPLY';
export const SELECT_SCHEDULE_TRACK = 'SELECT_SCHEDULE_TRACK';
export const SET_SELECTED_SCHEDULE_DETAILS = 'SET_SELECTED_SCHEDULE_DETAILS';
export const SESSION_VIDEO_MODAL_DETAILS = 'SESSION_VIDEO_MODAL_DETAILS';
export const THIS_SESSION_RATING_FORM = 'THIS_SESSION_RATING_FORM';
export const SESSION_POLL_NOT_SUBMITTED = 'SESSION_POLL_NOT_SUBMITTED';
export const SESSION_BY_TAG_FILTERED = 'SESSION_BY_TAG_FILTERED';
export const SESSION_COLORS = 'SESSION_COLORS';
export const ALL_EVENT_TRACKS = 'ALL_EVENT_TRACKS';
export const SESSION_FILTER_DATA = 'SESSION_FILTER_DATA';
export const SESSIONS_FOR_ALL_TRACKS = 'SESSIONS_FOR_ALL_TRACKS';

const sessionListRelated = `colordetails,speaker_by_speakerid,speaker_by_sessionspeakers,exhibitors_by_sessionexhibitors,sponsor_by_sessionsponsors,interactivemaps_by_interactivemaplocation_session_link,scheduletracks_by_scheduletrackid,appuser_access_by_sessionid&speaker_by_speakerid.fields=${FIELDS.speaker.minInfo}&speaker_by_sessionspeakers.fields=${FIELDS.speaker.minInfo}&exhibitors_by_sessionexhibitors.fields=${FIELDS.exhibitors.mediumInfo}&sponsor_by_sessionsponsors.fields=${FIELDS.sponsor.mediumInfo}&interactivemaps_by_interactivemaplocation_session_link.fields=interactivemapid&appuser_access_by_sessionid.fields=${FIELDS.appuseraccess.minInfo}`;

export const fetchScheduleData = (
  session,
  extra = {
    source: ALLOWED_SCHEDULEDATE_APICALL_SOURCE.session,
    selectedDate: null,
    apptabId: null,
    groupIds: null
  },
  callback
) => {
  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(isactive=1)${
      !_.isNil(extra.apptabId) ? `AND(apptabid=${extra.apptabId})` : ''
    })`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.scheduledates}?include_count=true&filter=${fetchFilter}&order=${FETCH_ORDERS.scheduledates}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        // mutable local scheduledate data
        let localScheduleDateData = { data: [], count: data.meta.count };
        _.map(data.resource, date => {
          let localDateObj = _.cloneDeep(date);

          // --- Destructuring track settings - Maintaining a flag not to show tracks where selected date has a '##NOTRACK##' track
          localDateObj.hideTrack = false;
          if (localDateObj?.ScheduleDateToScheduletracks.length) {
            localDateObj.ScheduleDateToScheduletracks = handleTracksAccess(
              session.userid,
              extra?.groupIds,
              localDateObj.ScheduleDateToScheduletracks
            );

            // Filtering all dates' tracks to find if '##NOTRACK##' is available
            let noTrackFilter = _.filter(
              localDateObj.ScheduleDateToScheduletracks,
              track => _.isEqual(track.trackname, SESSION_NO_TRACK)
            );
            localDateObj.hideTrack = noTrackFilter.length;
          }

          // Final push to local object
          localScheduleDateData.data.push(localDateObj);
        });

        dispatch({
          type: FETCH_SCHEDULES_DATA_FULFILLED,
          payload: localScheduleDateData
        });

        if (
          !_.includes(
            [
              ALLOWED_SCHEDULEDATE_APICALL_SOURCE.maps,
              ALLOWED_SCHEDULEDATE_APICALL_SOURCE.ads
            ],
            extra.source
          )
        ) {
          if (data.meta.count > 0) {
            let today = format(new Date(), DATE_FORMAT_FNS);

            let filterDataArr = [];
            if (!_.isEmpty(extra.selectedDate)) {
              filterDataArr = _.filter(
                localScheduleDateData.data,
                scd => scd?.scheduledateid == extra.selectedDate?.scheduledateid
              );
            } else {
              filterDataArr = _.filter(
                localScheduleDateData.data,
                scd => scd?.scheduledate == today
              );
            }

            if (filterDataArr.length > 0) {
              dispatch(
                fetchScheduleTracks(session, filterDataArr[0], extra, res => {})
              );
              dispatch(selectScheduleDate(filterDataArr[0]));
            } else {
              dispatch(
                fetchScheduleTracks(
                  session,
                  localScheduleDateData.data[0],
                  extra,
                  res => {}
                )
              );
              dispatch(selectScheduleDate(localScheduleDateData.data[0]));
            }
          } else {
            dispatch(fetchScheduleTracks(session, [], extra, res => {}));
            dispatch(selectScheduleDate([]));
          }

          // dispatch(
          //   selectScheduleDate(data.resource.length > 0 ? data.resource[0] : [])
          // );

          dispatch(
            fetchOverlappingAllTrackSessions(session, {
              apptabId: extra.apptabId,
              dates: localScheduleDateData.data
            })
          );
        }
        callback &&
          callback({
            success: 1,
            result: {
              response: localScheduleDateData.data,
              count: localScheduleDateData.count
            }
          });
      },
      error => {
        callback && callback({ success: 0, message: error });
      }
    );
  };
};

export const makeEmpty_ScheduleData = () => {
  return dispatch => {
    dispatch({ type: FETCH_SCHEDULES_DATA_FULFILLED, payload: {} });
  };
};

export const selectScheduleDate = date => {
  return {
    type: SELECT_SCHEDULE_DATE,
    payload: date
  };
};

export const fetchScheduleTracks = (
  session,
  data,
  extra = {
    source: 'session',
    apptabId: null
  },
  callback
) => {
  const fetchedTracks = !_.isEmpty(data?.ScheduleDateToScheduletracks)
    ? _.orderBy(data?.ScheduleDateToScheduletracks, ['displayorder'], ['asc'])
    : [];

  // ----- concat All tab if tracks length > 1
  const dispatchData =
    fetchedTracks.length > 1
      ? _.concat([{ trackname: 'All', type: 'fetchAll' }], fetchedTracks) // with all tab as concat
      : fetchedTracks; // w/o

  // ----- creates the track id string
  let trackIds = '(';
  if (fetchedTracks.length > 0) {
    _.map(fetchedTracks, (track, index) => {
      trackIds = `${trackIds}${track.scheduletrackid}${
        index == fetchedTracks.length - 1 ? ')' : ','
      }`;
    });
  }

  if (
    !_.includes(
      [
        ALLOWED_SCHEDULEDATE_APICALL_SOURCE.maps,
        ALLOWED_SCHEDULEDATE_APICALL_SOURCE.ads
      ],
      extra.source
    )
  ) {
    return dispatch => {
      if (!fetchedTracks.length || trackIds == '(') {
        dispatch({
          type: FETCH_SCHEDULES_TRACKS_DATA,
          payload: {
            data: [],
            count: 0
          }
        });
        dispatch(selectScheduleTrack({}));
      }

      trackIds != '(' &&
        dispatch(
          fetchAllSessionsForDate(
            session,
            {
              trackIds,
              apptabId: extra.apptabId
            },
            dispatchData,
            res => {
              if (res.success === 0) {
                callback({ success: 0, message: res.message });
              }
            }
          )
        );
    };
  } else {
    return dispatch => {
      dispatch({
        type: FETCH_SCHEDULES_TRACKS_DATA,
        payload: {
          data: fetchedTracks,
          count: fetchedTracks.length
        }
      });
      callback({ success: 1 });
    };
  }
};

export const selectScheduleTrack = track => {
  return dispatch => {
    dispatch({ type: SELECT_SCHEDULE_TRACK, payload: track });
  };
};

export const makeEmpty_ScheduleTracks = () => {
  return dispatch => {
    dispatch({ type: FETCH_SCHEDULES_TRACKS_DATA, payload: {} });
  };
};

// This dispatches processed list of tracks based on session count
export const fetchAllSessionsForDate = (
  session,
  value = { trackIds: '()', apptabId: null },
  allTracks = [],
  callback
) => {
  if (_.isEmpty(allTracks) || _.isEmpty(session?.sessionToken))
    return dispatch => {};

  const fetchFilter = encodeURI(
    `((scheduletrackid IN ${value.trackIds})AND(eventid=${session.eventid})AND(apptabid=${value.apptabId}))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&related=${sessionListRelated}&order=${FETCH_ORDERS.session}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        const sessionList = data.resource;
        const sessionCount = data.meta.count;
        const calendarViewSelected = _.isEqual(
          loadFromLocalDB(PORTAL_LOCALSTORAGE_ACCESS_KEY.schedule)?.view,
          ALLOWED_SCHEDULE_VIEWS.calendar
        );

        const trackWiseSessions = _.groupBy(sessionList, 'scheduletrackid');
        const allowedTracks = _.filter(
          allTracks,
          tr =>
            _.has(trackWiseSessions, tr?.scheduletrackid) ||
            _.isEqual(tr?.type, 'fetchAll')
        );

        // const tracksExceptAllCase = _.filter(
        //   allowedTracks,
        //   tr => !_.isEqual(tr?.type, 'fetchAll')
        // );
        const tracksExceptAllCase = _.filter(
          allTracks,
          tr => !_.isEqual(tr?.type, 'fetchAll')
        );

        // Processed tracks dispatched
        // const isSame = _.isEqual(allTracks.length, allowedTracks.length);
        // const allowedEmpty = _.isEmpty(allowedTracks);
        // const trackData = calendarViewSelected
        //   ? tracksExceptAllCase
        //   : !allowedEmpty && isSame
        //   ? allTracks
        //   : allowedTracks;
        // const trackCount = calendarViewSelected
        //   ? tracksExceptAllCase.length == 1
        //     ? 1
        //     : tracksExceptAllCase.length - 1
        //   : !allowedEmpty && isSame
        //   ? allTracks.length == 1
        //     ? 1
        //     : allTracks.length - 1
        //   : allowedTracks.length == 1
        //   ? 1
        //   : allowedTracks.length - 1;
        // const selectedTrack = calendarViewSelected
        //   ? tracksExceptAllCase[0]
        //   : !allowedEmpty && isSame
        //   ? allTracks[0]
        //   : !allowedEmpty
        //   ? allowedTracks[0]
        //   : {};
        const selectedTrack = calendarViewSelected
          ? tracksExceptAllCase[0]
          : allTracks[0];
        dispatch({
          type: FETCH_SCHEDULES_TRACKS_DATA,
          payload: {
            // data: trackData,
            // count: trackCount
            data: calendarViewSelected ? tracksExceptAllCase : allTracks,
            count: calendarViewSelected
              ? tracksExceptAllCase.length == 1
                ? 1
                : tracksExceptAllCase.length - 1
              : allTracks.length == 1
              ? 1
              : allTracks.length - 1
          }
        });
        dispatch(selectScheduleTrack(selectedTrack));

        // Session filters fetched
        dispatch(
          fetchSessionFilters(
            session,
            value.apptabId,
            allowedTracks,
            filterRes => {}
          )
        );

        // _.map(sessionList, item => {
        //   if (!_.isEmpty(item.speaker_by_speakerid)) {
        //     item.speaker_by_sessionspeakers.splice(
        //       0,
        //       0,
        //       item.speaker_by_speakerid
        //     );
        //   }
        // });

        const selectedTrackSessionList = _.filter(sessionList, sessItem =>
          _.isEqual(
            sessItem?.scheduletrackid,
            tracksExceptAllCase[0]?.scheduletrackid
          )
        );

        dispatch({
          type: FETCH_TRACK_SESSIONS_DATA,
          payload: {
            data: calendarViewSelected ? selectedTrackSessionList : sessionList,
            count: calendarViewSelected
              ? selectedTrackSessionList.length
              : sessionCount
          }
        });
        callback({
          success: 1,
          result: {
            response: calendarViewSelected
              ? selectedTrackSessionList
              : sessionList
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchTrackSessions = (
  session,
  extra = { scheduletrackid: null, apptabId: null },
  callback
) => {
  if (_.isEmpty(session?.sessionToken)) return dispatch => {};

  const fetchFilter = encodeURI(
    `((scheduletrackid=${extra.scheduletrackid})AND(eventid=${session.eventid})AND(apptabid=${extra.apptabId}))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&related=${sessionListRelated}&order=${FETCH_ORDERS.session}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        _.map(data.resource, item => {
          if (!_.isEmpty(item.speaker_by_speakerid)) {
            item.speaker_by_sessionspeakers.splice(
              0,
              0,
              item.speaker_by_speakerid
            );
          }
        });
        dispatch({
          type: FETCH_TRACK_SESSIONS_DATA,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const makeEmpty_TrackSessions = () => {
  return dispatch => {
    dispatch({ type: FETCH_TRACK_SESSIONS_DATA, payload: {} });
  };
};

export const setSessionDetailsAction = sessDetails => {
  return dispatch => {
    dispatch({ type: SET_SELECTED_SCHEDULE_DETAILS, payload: sessDetails });
  };
};

export const showSidebar = value => {
  return dispatch => {
    dispatch({ type: SHOW_SIDEBAR, payload: value });
  };
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};

export const deleteUserRsvpSession = (session, sessId, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(sessionid=${sessId})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionRsvp}?filter=(${filter})`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchRsvpSessionTotalAccess = (session, sessId, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(sessionid=${sessId})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionRsvp}?include_count=true&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({
          success: 1,
          totalaccess: res.meta.count,
          data: res.resource
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const rsvpSessionAccess = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionRsvp}`;
  let body = {
    resource: [{ ...values }]
  };
  let fetchFilter = encodeURI(`(sessionid=${values?.sessionid})`);
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?filter=${fetchFilter}`;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        getRequest(
          fetchUrl,
          session,
          dispatch,
          fetchRes => {
            callback({
              success: 1,
              response,
              fetchSuccess: 1,
              error: null,
              fetchResponse: fetchRes?.resource?.[0] ?? fetchRes,
              fetchError: null
            });
          },
          fetchError => {
            callback({
              success: 1,
              response,
              fetchSuccess: 0,
              error: null,
              fetchResponse: null,
              fetchError
            });
          }
        );
      },
      error => {
        callback({ success: 0, response: null, error: error });
      }
    );
  };
};

export const fetchliveqa = (
  session,
  sessionid,
  onlypublished,
  pageCount = 0,
  callback
) => {
  let perPage = 15;
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let filter = encodeURI(
    `((eventid=${session.eventid})AND(sessionid=${sessionid})${
      onlypublished ? 'AND(ispublished=1)' : ''
    })`
  );
  let orderby = encodeURI(
    `isimportant DESC,totallikes DESC,totalcomments DESC,displayorder DESC,createdon`
  );

  const related =
    'live_qa_likes_by_qaid,appuser_by_questionedby,live_qa_reply_by_qaid,appuser_by_replyby';

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveqa}?related=${related}&order=${orderby}&offset=${offset}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({
          success: 1,
          response: res.resource
        });
        dispatch({
          type: FETCH_SESSION_LIVEQA_DATA,
          payload: {
            data: res.resource
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearSessionLiveQa = () => {
  return dispatch => {
    dispatch({
      type: FETCH_SESSION_LIVEQA_DATA,
      payload: {}
    });
  };
};

export const openqaModal = value => {
  return dispatch => {
    dispatch({ type: OPEN_QA_MODAL, payload: value });
  };
};

export const addQue_liveqa = (session, resource, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveqa}`;
  let body = {
    resource: [resource]
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchLiveQAReply = (session, qaid, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})AND(qaid=${qaid})`);
  let limit = 15;
  let offset = 0;
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveQAReply}?related=appuser_by_replyby&include_count=true&limit=${limit}&offset=${offset}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
        let obj = {
          data: res.resource,
          count: res.meta.count
        };
        dispatch({ type: FETCH_LIVEQA_REPLY, payload: obj });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchThisQALikeCount = (session, qaid, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})AND(qaid=${qaid})`);
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveQALikes}?include_count=true&related=appuser_by_likedby&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        let hasLiked = _.filter(res.resource, qaLike => {
          return qaLike?.likedby == session.userid;
        });

        callback({
          success: 1,
          count: res.resource.length,
          liked: hasLiked.length > 0 ? true : false,
          likeid: hasLiked.length > 0 ? `${hasLiked[0]?.likeid}` : ''
        });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const addQA_reply = (session, resource, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveQAReply}`;
  let postBody = {
    resource: [{ ...resource }]
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearQA_reply = () => {
  return dispatch => {
    dispatch({ type: FETCH_LIVEQA_REPLY, payload: {} });
  };
};

export const updateAutoPublishLiveQA = (
  session,
  resourceObj,
  eventDetails,
  callback
) => {
  const patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.event}/${session.eventid}`;
  const patchBody = resourceObj;

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      res => {
        callback({ success: true });
        dispatch({
          type: EVENT_DETAILS,
          payload: {
            ...eventDetails,
            isautopublish_qa: resourceObj.isautopublish_qa
          }
        });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};

export const liveQALikeDislike = (session, type, values, callback) => {
  switch (type) {
    case 'like':
      const isPatch = values.likeid;

      let postUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveQALikes}`;
      if (isPatch) postUrl = `${postUrl}/${values.likeid}`;

      let postBody = {
        resource: [{ ..._.omit(values, ['likeid']) }]
      };
      if (isPatch)
        postBody = _.omit(values, [
          'liked',
          'likedby',
          'qaid',
          'likeid',
          'eventid'
        ]);

      return dispatch => {
        if (isPatch) {
          patchRequest(
            postUrl,
            postBody,
            session,
            dispatch,
            res => {
              callback({ success: 1 });
            },
            error => {
              callback({ success: 0, message: error });
            }
          );
        } else {
          postRequest(
            postUrl,
            postBody,
            session,
            dispatch,
            res => {
              callback({ success: 1 });

              // Gamification Status
              dispatch(
                fetchGameChallengeStatus(
                  session,
                  ALLOWED_GAME_CHALLENGE_TYPES.types.liveqalike,
                  response => {
                    if (response.data && response.data.iscompleted == true) {
                      if (response.data.showpopup == true) {
                        response.data.challengetype =
                          ALLOWED_GAME_CHALLENGE_TYPES.types.liveqalike;
                        dispatch(setGamificationPopup(true, response.data));
                      } else if (response.data?.showpopup) {
                        showToast(
                          `${LocalStrings.dynamic.kYouHaveGot} ${response.data.points} ${LocalStrings.dynamic.kPointsText}`
                        );
                      }
                    }
                  }
                )
              );
            },
            error => {
              callback({ success: 0, message: error });
            }
          );
        }
      };

    case 'dislike':
      let delUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveQALikes}/${values}`;
      return dispatch => {
        deleteRequest(
          delUrl,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {
            callback({ success: 0, message: error });
          }
        );
      };

    default:
      return dispatch => {};
  }
};

export const updateLiveQAPinPublish = (session, qaid, value, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.liveqa}/${qaid}`;

  return dispatch => {
    patchRequest(
      url,
      value,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const deleteLiveQA = (session, data, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.liveQA.delete.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.liveQA.delete.payload);
  postBody.sessionid = data.sessionid;
  postBody.qaid = data.qaid;
  postBody.userid = session.userid;

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionPolls = (
  session,
  extra = { sessionId: null, pollId: null },
  callback
) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.poll.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.getCommon.poll.payload);
  postBody.eventid = session.eventid;
  postBody.sessionid = extra.sessionId;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        if (_.isEmpty(extra?.pollId)) {
          // Following format used to be API response of liveqa(requesttype: 'fetchpoll')
          // But as reducer format is same, converting current response into the same
          // totalcount: 4, publishedcount: '1', unpublishedcount: '3', notsubmittedpoll: 0, data: Array(1)

          let filterActivePolls = _.filter(
            res.resource,
            poll => !poll?.isarchived
          );
          let filterArchivedPolls = _.filter(
            res.resource,
            poll => poll?.isarchived
          );
          let notAnsweredPolls = _.filter(
            res.resource,
            poll => !_.isEmpty(poll?.info) && _.isEmpty(poll?.info?.answer)
          );

          let obj = {
            totalcount: res.resource.totalcount,
            publishedcount: filterActivePolls.length,
            unpublishedcount: filterArchivedPolls.length,
            notsubmittedpoll: notAnsweredPolls.length,
            data: res.resource
          };

          let payloadObj = {
            data: res.resource,
            count: res.resource.length,
            fetchData: obj,
            ...extra
          };

          dispatch({
            type: SESSION_POLL_LIST,
            payload: payloadObj
          });
          callback({ success: 1, response: payloadObj });
        } else {
          let filterPoll = _.find(
            res.resource,
            poll => poll?.pollid == extra?.pollId
          );
          callback({ success: 1, response: { filterPoll, ...extra } });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchNotSubmittedPollCounts = (session, sessionid, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.liveQA.noSubmittedPoll.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.liveQA.noSubmittedPoll.payload);
  postBody.sessionid = sessionid;
  postBody.userid = session.userid;

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        // correct res format
        // totalcount: 4, publishedcount: '1', unpublishedcount: '3', notsubmittedpoll: 0, data: Array(1)
        let obj = {
          totalcount: res.resource.totalcount,
          publishedcount: JSON.parse(res.resource.publishedcount),
          unpublishedcount: JSON.parse(res.resource.unpublishedcount),
          notsubmittedpoll: res.resource.notsubmittedpoll
        };
        dispatch({
          type: SESSION_POLL_NOT_SUBMITTED,
          payload: {
            data: res.resource.data,
            count: res.resource.notsubmittedpoll,
            fetchData: obj
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearNotSubmittedPollCounts = () => {
  return dispatch =>
    dispatch({
      type: SESSION_POLL_NOT_SUBMITTED,
      payload: { count: 0 }
    });
};

export const clearSessionPolls = () => {
  return dispatch => {
    dispatch({
      type: SESSION_POLL_LIST,
      payload: {}
    });
  };
};

export const pollListModal = obj => {
  return dispatch => {
    dispatch({ type: SESSION_POLL_LIST_MODAL, payload: obj });
  };
};

export const pollActionModal = obj => {
  return dispatch => {
    dispatch({ type: SESSION_POLL_ACTION_MODAL, payload: obj });
  };
};

export const savePollAns = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.pollResults}`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
        dispatch(singlePoll(session, values.pollid, res => {}));
      },
      error => {}
    );
  };
};

export const pollResult = resultValue => {
  // let url = `${session.instance_url}${SCRIPT_URI_ADDON}/eventifyscript_support`;
  // let body = { type: 'pollResult', pollid: pollid, eventid: session.eventid };

  return dispatch => {
    dispatch({
      type: SESSION_POLL_RESULT,
      payload: resultValue
    });
    setTimeout(() => {
      dispatch({
        type: SESSION_POLL_RESULT,
        payload: resultValue
      });
    }, 100);
    // postRequest(
    //   url,
    //   body,
    //   session,
    //   dispatch,
    //   response => {
    //     dispatch({
    //       type: SESSION_POLL_RESULT,
    //       payload: response
    //     });
    //     callback({ success: 1, resource: response });
    //   },
    //   error => {
    //     callback({ success: 0, message: error });
    //   }
    // );
  };
};

export const singlePoll = (session, pollid, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(pollid=${pollid})AND(isarchived=0)`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.pollQuestions}?include_count=true&related=poll_results_by_pollid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch(
          pollActionModal({
            showModal: true,
            modalData: data?.resource.length > 0 ? data.resource[0] : []
          })
        );
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const makeEmpty_pollResult = () => {
  return dispatch => {
    dispatch({
      type: SESSION_POLL_RESULT,
      payload: {}
    });
  };
};

export const addLiveQaPoll = (session, resourceObj, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.pollQuestions}`;
  let postBody = {
    resource: [{ ...resourceObj }]
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchBookedSchedule = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=schedule)`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?include_count=true&fields=${FIELDS.bookmarks.minInfo}&filter=(${filter})`;

  return dispatch => {
    dispatch({
      type: MY_BOOKED_SCHEDULE,
      payload: {}
    });
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: MY_BOOKED_SCHEDULE,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const setScheduleInBookmark = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}`;
  let body = {
    resource: values
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const removeScheduleFromBookmark = (
  session,
  bookmarkId,
  typeId,
  callback
) => {
  let delFilter = typeId ? encodeURI(`typeid=${typeId}`) : '';
  let bookIdUrlExt = bookmarkId ? `/${bookmarkId}` : '';

  let delUrl = `${session.instance_url}${TABLE_URI_ADDON}/${
    TABLES.bookmarks
  }${bookIdUrlExt}${!_.isEmpty(delFilter) ? `?filter=(${delFilter})` : ``}`;

  return dispatch => {
    deleteRequest(
      delUrl,
      session,
      dispatch,
      response => {
        fetchBookedSchedule(session, res => {});
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const storeSessionRatings = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionRatings}`;
  let body = {
    resource: [{ ...values }]
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
        dispatch(fetchRatedSessions(session, res => {}));

        // Gamification Status
        dispatch(
          fetchGameChallengeStatus(
            session,
            ALLOWED_GAME_CHALLENGE_TYPES.types.ratesession,
            response => {
              if (response.data && response.data.iscompleted == true) {
                if (response.data.showpopup == true) {
                  response.data.challengetype =
                    ALLOWED_GAME_CHALLENGE_TYPES.types.ratesession;
                  dispatch(setGamificationPopup(true, response.data));
                } else if (response.data?.showpopup) {
                  showToast(
                    `${LocalStrings.dynamic.kYouHaveGot} ${response.data.points} ${LocalStrings.dynamic.kPointsText}`
                  );
                }
              }
            }
          )
        );
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchRatedSessions = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionRatings}?include_count=true&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: MY_RATED_SESSION,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const holdThisSessionDetails = obj => {
  return dispatch => {
    dispatch({
      type: HOLD_THIS_SESSION_DETAILS,
      payload: obj
    });
  };
};

export const setSessionVideoModalDetails = obj => {
  return dispatch => {
    dispatch({ type: SESSION_VIDEO_MODAL_DETAILS, payload: obj });
  };
};

export const fetchSessionLinkedAssociates = (
  session,
  extra = { scheduleId: null, apptabId: null },
  callback
) => {
  let filter = encodeURI(
    `((eventid=${session.eventid})AND(sessionid=${extra.scheduleId})AND(apptabid=${extra.apptabId}))`
  );

  let sessionTableFields = `colordetails,speaker_by_speakerid,speaker_by_sessionspeakers,scheduletracks_by_scheduletrackid,exhibitors_by_sessionexhibitors,sponsor_by_sessionsponsors`;

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?related=${sessionTableFields}&filter=${filter}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        if (!_.isEmpty(res.resource[0]?.speaker_by_speakerid)) {
          res.resource[0].speaker_by_sessionspeakers.splice(
            0,
            0,
            res.resource[0].speaker_by_speakerid
          );
        }
        callback({
          success: 1,
          data: {
            speakers: {
              data: res.resource[0]?.speaker_by_sessionspeakers,
              count: res.resource[0]?.speaker_by_sessionspeakers.length
            },
            exhibitors: {
              data: res.resource[0]?.exhibitors_by_sessionexhibitors,
              count: res.resource[0]?.exhibitors_by_sessionexhibitors.length
            },
            sponsors: {
              data: res.resource[0]?.sponsor_by_sessionsponsors,
              count: res.resource[0]?.sponsor_by_sessionsponsors.length
            }
          },
          messahe: null
          // data: res.resource[0]?.speaker_by_sessionspeakers,
          // count: res.resource[0]?.speaker_by_sessionspeakers.length
        });
      },
      error => {
        callback({ success: 0, data: null, message: error });
      }
    );
  };
};

export const fetchSessionRatingForm = (
  session,
  extra = { sessionid: null, apptabId: null },
  callback
) => {
  let filter = encodeURI(
    `((eventid=${session.eventid})AND(sessionid=${extra.sessionid})AND(apptabid=${extra.apptabId}))`
  );
  let related = 'event_forms_by_sessionratingid';
  let getUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?related=${related}&filter=${filter}`;

  return dispatch => {
    getRequest(
      getUrl,
      session,
      dispatch,
      res => {
        dispatch({
          type: THIS_SESSION_RATING_FORM,
          payload: { data: res.resource, count: res.meta.count }
        });
        callback({
          success: 1,
          data: { data: res.resource, count: res.meta.count }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionsByTags = (
  session,
  tag,
  extra = { apptabId: null },
  callback
) => {
  let fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(apptabid=${extra.apptabId})AND(tags CONTAINS ${tag}))`
  );
  let fetchOrderby = FETCH_ORDERS.session;
  let fetchRelated =
    'colordetails,speaker_by_speakerid,speaker_by_sessionspeakers,exhibitors_by_sessionexhibitors,sponsor_by_sessionsponsors,interactivemaps_by_interactivemaplocation_session_link,scheduletracks_by_scheduletrackid&interactivemaps_by_interactivemaplocation_session_link.fields=interactivemapid';
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&related=${fetchRelated}&order=${fetchOrderby}&filter=${fetchFilter}`;

  return dispatch => {
    dispatch({
      type: SESSION_BY_TAG_FILTERED,
      payload: {}
    });
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        _.map(data.resource, item => {
          if (!_.isEmpty(item.speaker_by_speakerid)) {
            item.speaker_by_sessionspeakers.splice(
              0,
              0,
              item.speaker_by_speakerid
            );
          }
        });
        dispatch({
          type: SESSION_BY_TAG_FILTERED,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionColors = (session, callback = () => {}) => {
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionColors}?include_count=true`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        let payloadObj = {
          data: res.resource,
          count: res.meta.count
        };
        dispatch({ type: SESSION_COLORS, payload: payloadObj });
        callback({ ...payloadObj, success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionComments = (
  session,
  extra = { sessionId: null, apptabId: null },
  callback
) => {
  const filter = encodeURI(
    `((eventid=${session.eventid})AND(sessionid=${extra.sessionId})AND(apptabid=${extra.apptabId}))`
  );
  const related = 'comments_by_sessionid,appuser_by_comments';
  const url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?&related=${related}&filter=${filter}`;
  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        const response = res.resource.map(ea => ({
          ...ea,
          comments_by_sessionid: shuffleComments(
            'commentid',
            ea.comments_by_sessionid
          )
        }));
        callback({ success: 1, data: response[0] });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionFilters = (session, apptabid, tracks, callback) => {
  let fetchUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.sessionFilters.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.getCommon.sessionFilters.payload);
  postBody.apptabid = apptabid;

  return dispatch => {
    postRequest(
      fetchUrl,
      postBody,
      session,
      dispatch,
      res => {
        const allowedTracks = [];
        _.map(tracks, tr => {
          if (!_.isEqual(tr?.type, 'fetchAll'))
            allowedTracks.push({
              name: tr?.trackname
            });
        });
        const payloadData = {
          ...res,
          tracks: allowedTracks
        };
        dispatch({ type: SESSION_FILTER_DATA, payload: payloadData });
        callback({ success: 1, data: payloadData });
      },
      errors => {
        callback({ success: 0, data: [] });
      }
    );
  };
};

export const checkSessionIsAgenda = (session, sessId, callback) => {
  let bkmrkFilter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=schedule)AND(typeid=${sessId}))`
  );
  let bkmrkUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?filter=${bkmrkFilter}`;

  let rsvpFilter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid})AND(sessionid=${sessId}))`
  );
  let rsvpUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionRsvp}?filter=${rsvpFilter}`;

  return dispatch => {
    getRequest(
      rsvpUrl,
      session,
      dispatch,
      rsvpRes => {
        getRequest(
          bkmrkUrl,
          session,
          dispatch,
          bkmrkRes => {
            callback({
              success: 1,
              isAgenda: bkmrkRes?.resource?.length && rsvpRes?.resource?.length,
              rsvp: rsvpRes?.resource?.length,
              bkmrk: bkmrkRes?.resource?.length,
              rsvpId: rsvpRes?.resource?.[0]?.id,
              bkmrkId: bkmrkRes?.resource?.[0]?.bookmarkid
            });
          },
          error => {
            callback({ success: 0, message: error });
          }
        );
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const markPollActiveArchive = (
  session,
  extra = { pollId: null, active: false },
  callback
) => {
  let patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.pollQuestions}/${extra.pollId}`;
  let patchBody = {
    isarchived: extra.active
  };

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, error: null });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const fetchSessionCheckedInStatus = (
  session,
  extra = { sessionId: null },
  callback
) => {
  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(checkinbyid=${session.userid})AND(sessionid=${extra.sessionId}))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionCheckIn}?fields=${FIELDS.sessionCheckIn.mediumInfo}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        const entry = res.resource?.[0];
        const checkedIn = !_.isEmpty(entry);
        const checkedOut = checkedIn && !_.isEmpty(entry?.checkouton);
        const status = checkedOut
          ? ALLOWED_SESSION_CHECKED_IN_TYPES.checkedOut
          : checkedIn
          ? ALLOWED_SESSION_CHECKED_IN_TYPES.checkedIn
          : ALLOWED_SESSION_CHECKED_IN_TYPES.open;

        callback({ success: 1, status, entry, error: null });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const performSelfCheckinCheckout = (
  session,
  extra = { updateFor: null, values: {} },
  callback
) => {
  if (_.isEmpty(extra?.values))
    return dispatch => callback({ success: 0, error: 'Missing payload' });

  const updateFilter = extra?.updateFor
    ? encodeURI(
        `((eventid=${session?.eventid})AND(checkinbyid=${session?.userid})AND(sessionid=${extra?.updateFor}))`
      )
    : '';
  const tableUrl = `${session.instance_url}${TABLE_URI_ADDON}/${
    TABLES.sessionCheckIn
  }${extra?.updateFor ? `?filter=${updateFilter}` : ''}`;
  const payloadBody = {
    resource: [extra?.values]
  };

  return dispatch => {
    if (extra?.updateFor) {
      patchRequest(
        tableUrl,
        payloadBody,
        session,
        dispatch,
        res => {
          callback({ success: 1, error: null });
        },
        error => {
          callback({ success: 0, error });
        }
      );
    } else {
      postRequest(
        tableUrl,
        payloadBody,
        session,
        dispatch,
        res => {
          callback({ success: 1, error: null });
        },
        error => {
          callback({ success: 0, error });
        }
      );
    }
  };
};

export const fetchAllEventTracks = (
  session,
  extra = { groupIds: [] },
  callback = null
) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.scheduletracks}?include_count=true&fields=${FIELDS.scheduletracks.mediumInfo}&filter=${fetchFilter}&order=${FETCH_ORDERS.scheduletracks}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        const returnVal = handleTracksAccess(
          session.userid,
          extra?.groupIds,
          res.resource
        );
        dispatch({ type: ALL_EVENT_TRACKS, payload: returnVal });
        callback && callback({ success: 1, error: null });
      },
      error => {
        callback && callback({ success: 0, error });
      }
    );
  };
};

export const getSessionQr = (sessionid, session, callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventQr.sessionQr.endpoint}`;
  let payload = SCRIPTS.eventQr.sessionQr.payload;
  payload.eventid = session.eventid;
  payload.sessionid = sessionid;

  return dispatch => {
    postRequest(
      postUrl,
      payload,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res });
      },
      error => {
        callback({ success: 0, data: {} });
      }
    );
  };
};

export const exportSessionPollResult = (
  session,
  extra = { postId: null },
  callback
) => {
  if (_.isNull(extra?.postId)) return dispatch => {};

  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.postCommon.sessionPollExport.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.postCommon.sessionPollExport.payload);
  postBody.eventid = session.eventid;
  postBody.id = extra.postId;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        if (!res?.success || res?.success == 0) {
          callback({ success: 0, data: null, error: null });
        } else {
          downloadFileFromURL(res?.path);
          callback({ success: 1, data: res, error: null });
        }
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const fetchMinDataOfSelectedSchedule = (
  session,
  extra = { sessionId: null, apptabId: null },
  callback
) => {
  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(apptabid=${extra?.apptabId})AND(sessionid=${extra?.sessionId}))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?fields=${FIELDS.session.minInfo}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource?.[0], error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const fetchOverlappingAllTrackSessions = (
  session,
  extra = { apptabId: null, dates: [] },
  callback = null
) => {
  if (_.isEmpty(session?.sessionToken)) return dispatch => {};

  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(apptabid=${extra?.apptabId})AND(foralltracks=1))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?related=${sessionListRelated}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        const fetched = res?.resource;

        const payload = {};
        _.map(extra?.dates, date => {
          if (date?.isactive)
            payload[date.scheduledateid] = {
              apptabid: date.apptabid,
              scheduledateid: date.scheduledateid,
              scheduledate: date.scheduledate,
              tracks: _.map(date?.ScheduleDateToScheduletracks, track =>
                Number(track?.scheduletrackid)
              ),
              sessions: []
            };
        });

        _.map(fetched, sess => {
          const foundDate = _.find(
            payload,
            dateObj =>
              !_.isEmpty(dateObj?.tracks) &&
              _.isEqual(
                dateObj?.scheduledateid,
                sess?.scheduletracks_by_scheduletrackid?.scheduledateid
              )
          );
          if (foundDate) payload[foundDate.scheduledateid].sessions.push(sess);
        });

        dispatch(updateOverlappingAllTrackSessions(payload));
        callback && callback({ success: 1, data: payload, error: null });
      },
      error => {
        callback && callback({ success: 0, data: null, error });
      }
    );
  };
};

export const updateOverlappingAllTrackSessions = payload => {
  return dispatch => dispatch({ type: SESSIONS_FOR_ALL_TRACKS, payload });
};

const handleTracksAccess = (userId, groupIds = [], tracks = []) => {
  const returnVal = [];
  _.map(tracks, track => {
    let isAllowed = false;
    const trackSettings = track?.tracksettings
      ? _.attempt(JSON.parse, track?.tracksettings)
      : track?.tracksettings;

    const { assignedusers, assignedgroups } = trackSettings || {};
    if (trackSettings) {
      const specificUsers = _.map(assignedusers, ea => Number(ea));
      const specificGroups = _.map(assignedgroups, ea => Number(ea));

      isAllowed =
        (!_.isEmpty(specificUsers) && _.includes(specificUsers, userId)) ||
        (!_.isEmpty(specificGroups) &&
          _.intersection(specificGroups, groupIds).length) ||
        (_.isEmpty(specificUsers) && _.isEmpty(specificGroups));
    } else isAllowed = true;

    isAllowed &&
      returnVal.push({
        ...track,
        tracksettings: trackSettings
      });
  });

  return _.orderBy(returnVal, ['displayorder'], ['asc']);
};

export const updateSessionDetails = (
  session,
  extra = { values: {} },
  callback = () => {}
) => {
  if (_.isEmpty(extra?.values))
    return dispatch =>
      callback({ success: 0, data: null, error: 'Required params missing.' });

  const patchUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.postCommon.sessionEdit.endpoint}`;
  const patchBody = extra?.values;

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
